// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"de81b5cd","977":"fecec3df"}[chunkId] + ".chunk.js";
};